"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Passive_ReflectiveCurse_OnEffectAppliedEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
let Effect_Passive_ReflectiveCurse_OnEffectAppliedEventHandlerScript = class Effect_Passive_ReflectiveCurse_OnEffectAppliedEventHandlerScript {
    run(sequence, container, handler, event) {
        const effect = container.getEffect(event.args.effectId);
        if (!effect.args.harmful) {
            return;
        }
        else if (effect.creatorId === event.subject) {
            return;
        }
        container.applyDebuff({
            sequence,
            attackerId: event.subject,
            targetId: effect.creatorId,
            effect: effect.args,
            duration: effect.duration,
            supernatural: effect.supernatural,
            onAppliedOrResisted(sequence) {
                container.cancelEffect(sequence, effect.id);
            },
        });
    }
};
Effect_Passive_ReflectiveCurse_OnEffectAppliedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Passive_ReflectiveCurse_OnEffectApplied")
], Effect_Passive_ReflectiveCurse_OnEffectAppliedEventHandlerScript);
exports.Effect_Passive_ReflectiveCurse_OnEffectAppliedEventHandlerScript = Effect_Passive_ReflectiveCurse_OnEffectAppliedEventHandlerScript;
